import React, { useState, useRef } from 'react'
import Modal from 'react-bootstrap-modal'
import ConfirmRefundModal from './confirm-refund-modal'

function SplitDropModal({drop, onClose, onSubmit}) {
  const amountCreditRef = useRef()
  const amountCancellationRef = useRef()
  const amountRefundRef = useRef()
  const [showAlert, setShowAlert] = useState(true)
  const [alert, setAlert] = useState('Make changes')
  const [dropAmount, setDropAmount] = useState(parseFloat(drop.amount))
  const [resultAmounts, setResultAmounts] = useState(null)
  const [showConfirm, setShowConfirm] = useState(false)
  let timer = null

  const onAlert = (alertMessage) => {
    setAlert(alertMessage)
    setShowAlert(true)
    clearTimeout(timer)
    timer = setTimeout(() => {setShowAlert(false)}, 2000)
  }

  const updateAmount = () => {
    var categoryAmounts = [
      ['game_credit', drop.category == 'game_credit' ? '0' : amountCreditRef.current.value],
      ['cancellation', drop.category == 'cancellation' ? '0' : amountCancellationRef.current.value]
    ]
    if (drop.refund_enabled) categoryAmounts.push(['refund', !drop.refund_enabled ? '0' : amountRefundRef.current.value])
    categoryAmounts = categoryAmounts.map((el) => [el[0], el[1] == '' ? 0 : parseFloat(el[1])])

    if (categoryAmounts.some((el) => el[1] < 0)) return onAlert('Negative value')
    const addedAmount = categoryAmounts.reduce((sum, el) => sum = sum + el[1], 0)
    if (addedAmount == 0) return onAlert('Make changes')
    if (addedAmount > parseFloat(drop.amount)) return onAlert('Amount exceeded')
    setShowAlert(false)
    setAlert(null)

    const newDropAmount = (parseFloat(drop.amount) - addedAmount).toFixed(2)
    setDropAmount(newDropAmount)

    const updatedAmounts = categoryAmounts.map((el) => [el[0], el[0] == drop.category ? newDropAmount : el[1]])
    setResultAmounts(updatedAmounts)
  }

  const onSplitSubmit = ()=> {
    if (alert) return onAlert(alert)
    if (drop.refund_enabled && parseFloat(resultAmounts[2][1]) > 0) setShowConfirm(true)
    else onSubmit(resultAmounts)
  }

  return <Modal container={document.body} show={true} onHide={onClose} className='sorting-modal'>
    <Modal.Header closeButton>
      <Modal.Title>Split Drop</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <table className='table table-striped'>
        <thead>
        <tr>
          <th className='col-xs-8'>Category</th>
          <th className='col-xs-4'>Amount</th>
        </tr>
        </thead>
        <tbody>
          {showConfirm &&
            <ConfirmRefundModal
              onClose={() => setShowConfirm(false)}
              onSubmit={() => onSubmit(resultAmounts)}
            />
          }
          <tr>
            <td>game credit</td>
            <td>
              {drop.category == 'game_credit' ? dropAmount :
                <input name='game_credit-input' placeholder='0' step='0.1' type='number' ref={amountCreditRef}
                  min='0' max={dropAmount} onBlur={updateAmount}
                />
              }
            </td>
          </tr>
          <tr>
            <td>cancellation</td>
            <td>
              {drop.category == 'cancellation' ? dropAmount :
                <input name='cancellation-input' placeholder='0' step='0.1' type='number' ref={amountCancellationRef}
                  min='0' max={dropAmount} onBlur={updateAmount}
                />
              }
            </td>
          </tr>
          {drop.refund_enabled &&
            <tr>
              <td>refund</td>
              <td>
                <input name='refund-input' placeholder='0' step='0.1' type='number' ref={amountRefundRef}
                  min='0' max={dropAmount} onBlur={updateAmount}
                />
              </td>
            </tr>
          }
        </tbody>
      </table>
      <div className='form-group'>
        <div className='col-sm-6 text-center'>
          { showAlert && alert }
        </div>
        <div className='col-sm-3 text-center'>
          <button className='btn btn-default' onClick={onClose}>Cancel</button>
        </div>
        <div className='col-sm-3 text-center'>
          <button className='btn btn-primary' onClick={onSplitSubmit}>Split</button>
        </div>
      </div>
    </Modal.Body>
  </Modal>
}

export default SplitDropModal
